import React, { useContext } from 'react'
import { ChangePresentContext, MedPlanContext } from '../../SingleEvent'
import Grid from '@mui/material/Grid'
import DestinationPicker from './DestinationPicker'

const NearestTraumaUnit = ({ destinationOptions, loadOptions }) => {
  const { medPlan, setMedPlan } = useContext(MedPlanContext)
  const { changesPresent, setChangesPresent } = useContext(ChangePresentContext)

  return (
    <Grid item xs={12} lg={4}>
      <DestinationPicker
        value={medPlan?.nearestTraumaUnit ?? null}
        label="Nearest Trauma Unit"
        type="Trauma Unit"
        loadOptions={loadOptions}
        destinationOptions={destinationOptions}
        onChange={(e, newValue) => {
          setMedPlan((prev) => ({
            ...prev,
            nearestTraumaUnit: newValue,
          }))
          !changesPresent && setChangesPresent(true)
        }}
        onEditSubmit={(newValue) => {
          setMedPlan((prev) => ({
            ...prev,
            nearestTraumaUnit: newValue,
          }))
          !changesPresent && setChangesPresent(true)
        }}
      />
    </Grid>
  )
}

export default React.memo(NearestTraumaUnit)
